<template>
    <label
        class="relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus-within:outline-none focus-within:ring-2 focus-within:ring-slate-300 focus-within:ring-offset-2"
        :class="{
            'bg-orange': props.value && !props.disabled,
            'bg-gray-200': !props.value || props.disabled,
            'cursor-pointer': !props.disabled,
            'cursor-not-allowed opacity-60': props.disabled,
        }"
        role="switch"
    >
        <span class="sr-only">{{ label }}</span>
        <input
            type="checkbox"
            class="absolute inset-0 opacity-0 cursor-pointer"
            @change="handleInput"
            @keydown.enter.prevent="
                handleInput({ target: { checked: !isChecked } })
            "
            :value="props.value"
            :checked="isChecked"
            :disabled="props.disabled"
        />
        <span
            aria-hidden="true"
            class="inline-flex items-center justify-center h-5 w-5 transform rounded-full bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50 ring-0 transition duration-200 ease-in-out"
            :class="{
                'translate-x-5': props.value,
                'translate-x-0': !props.value,
            }"
        >
            <i
                class="fa-solid fa-check fa-xs transition"
                :class="{
                    'opacity-100 delay-300': props.value,
                    'opacity-0': !props.value,
                    'text-orange': !props.disabled,
                    'text-gray-400': props.disabled,
                }"
            ></i>
        </span>
    </label>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    value: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['input']);
const isChecked = computed(() => props.value);

const handleInput = (value) => {
    if (props.disabled) return;
    emit('input', value.target.checked);
};
</script>
